import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import esTranslation from './locales/es.json';
import enTranslation from './locales/en.json';
import caTranslation from './locales/ca.json';
import frTranslation from './locales/fr.json';
import clTranslation from './locales/cl.json';
import plTranslation from './locales/pl.json';

const resources = {
    en: {
        translation: enTranslation
    },
    es: {
        translation: esTranslation
    },
    ca: {
        translation: caTranslation
    },
    fr: {
        translation: frTranslation
    },
    cl: {
        translation: clTranslation
    },
    pl: {
        translation: plTranslation
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'es',
        fallbackLng: 'es',
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
